import { getPreloadedLoomMeetingRecorderEligibility } from '@confluence/loom-utils/entry-points/getPreloadedLoomMeetingRecorderEligibility.ts';
import { fg } from '@confluence/feature-gating';

const MEETING_RECORDER_ELIGIBILITY_UNDEFINED_ERROR = new Error(
	'Meeting Recorder eligibility data is undefined',
);

export type UseMeetingRecorderEligibilityResult = {
	/** null when the TAP cohort is excluded or the View Page preload has no eligibility data. */
	isAvailable: boolean | null;
	error: Error | null;
};

/** Reads Loom settings from the View Page preload after the TAP cohort and feature gate admit the user. */
export function useMeetingRecorderEligibility({
	isHighTouch,
	isLowTouch,
}: {
	isHighTouch: boolean | null;
	isLowTouch: boolean | null;
}): UseMeetingRecorderEligibilityResult {
	const isHighTouchEnabled = isHighTouch === true && fg('twcg-2202-loom-meeting-nudge-ht-gate');
	const isLowTouchEnabled = isLowTouch === true && fg('twcg-2202-loom-meeting-nudge-lt-gate');
	const shouldLoadLoomData = isHighTouchEnabled || isLowTouchEnabled;

	const loomData = shouldLoadLoomData ? getPreloadedLoomMeetingRecorderEligibility() : undefined;

	return {
		isAvailable:
			loomData === undefined
				? null
				: loomData.meetingRecordingsAvailable === true && loomData.connectedCalendars?.length === 0,
		error:
			shouldLoadLoomData && loomData === undefined
				? MEETING_RECORDER_ELIGIBILITY_UNDEFINED_ERROR
				: null,
	};
}
